import React, { useState, useEffect } from 'react';
import { Music } from 'lucide-react';
import { getFileUrl } from '@/services/musicTracksService';
import { cn } from '@/lib/utils';

interface TrackCoverProps {
  coverPath?: string | null;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  /** Append to image URL to bypass cache after cover replace (e.g. track.updatedAt) */
  cacheBuster?: string | number | null;
}

const sizeClasses = {
  sm: 'h-10 w-10',
  md: 'h-12 w-12',
  lg: 'h-20 w-20',
};

export function TrackCover({
  coverPath,
  className,
  size = 'md',
  cacheBuster = null,
}: TrackCoverProps) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!coverPath) {
      setUrl(null);
      setError(false);
      return;
    }
    setError(false);
    getFileUrl(coverPath)
      .then(setUrl)
      .catch(() => setError(true));
  }, [coverPath]);

  if (!coverPath || error || !url) {
    return (
      <div
        className={cn(
          'flex shrink-0 items-center justify-center rounded-md bg-muted',
          sizeClasses[size],
          className
        )}
      >
        <Music className="h-1/2 max-h-6 w-1/2 max-w-6 text-muted-foreground" />
      </div>
    );
  }

  const imgSrc =
    cacheBuster != null && cacheBuster !== ''
      ? `${url}?t=${encodeURIComponent(String(cacheBuster))}`
      : url;

  return (
    <img
      src={imgSrc}
      alt=""
      className={cn(
        'shrink-0 rounded-md object-cover bg-muted',
        sizeClasses[size],
        className
      )}
    />
  );
}
